import { render, staticRenderFns } from "./TotalSystemAdmin.vue?vue&type=template&id=32ca8b78&scoped=true"
import script from "./TotalSystemAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./TotalSystemAdmin.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TotalSystemAdmin.vue?vue&type=style&index=0&id=32ca8b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ca8b78",
  null
  
)

export default component.exports